import { enableLocalization, registerUI } from '@uxp';
import { QueryBuilder } from '@query-builder/QueryBuilder';
import { QueryPreview } from '@query-builder/QueryPreview';
import Test from '@query-builder/Test/Test';
import './styles.scss';
import { useQueryEngineService } from '@query-builder/useQueryEngineService';
window.QueryBuilderComponents = {
    QueryBuilder: QueryBuilder,
    QueryPreview: QueryPreview,
    useQueryEngineService: useQueryEngineService
};
registerUI({
    id: "lucy-query-builder",
    component: Test,
    showDefaultHeader: false
});
enableLocalization();
